import { render, staticRenderFns } from "./custodia-historias-editar.vue?vue&type=template&id=5df68a23&scoped=true&"
import script from "./custodia-historias-editar.vue?vue&type=script&lang=js&"
export * from "./custodia-historias-editar.vue?vue&type=script&lang=js&"
import style0 from "./custodia-historias-editar.vue?vue&type=style&index=0&id=5df68a23&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df68a23",
  null
  
)

export default component.exports